import React from "react";
import { format } from "date-fns";
//redux
import { useSelector } from "react-redux";
import { RootState } from "store/ducks";
//components
import Text from "components/Text";
import HeaderIndicator from "../HeaderIndicador";
import { Visibility } from "components/Visibility";
import { Column, Row } from "components/Layout/Grid";
//styled-components
import { Container } from "./styles";
//interfaces
import { IQuoteHeaderInformations } from "./interface";
//utils
import { SupplierStatusType } from "components/Table/interface";
import { getCustomStatusDescription } from "pages/Quotes/Dashboard/GridQuotes/utils";
import { IsNullOrEmpty } from "utils/StringNullOrEmpty";
import Parse from 'html-react-parser';
//context
import { useDetailsQuoteContext } from "contexts/DetailsQuote";
//styles
import '../../styles.scss';
import '../../SavedInMoney/styles.scss';

const QuoteHeaderInformations: React.FC<IQuoteHeaderInformations> = (props) => {
  const {
    supplierStatus,
    moneyBudgetValue,
    savedInMoneyPage,
    integrationMessages
  } = props;

  const { quoteDetail } = useDetailsQuoteContext();
  const user = useSelector((stateUser: RootState) => stateUser.user);

  const unionMessage = `${quoteDetail?.notParticipateStatus}, ${quoteDetail?.notParticipateStatusMessage}`;
  const notParticipateControl = quoteDetail?.supplierStatus === SupplierStatusType.DO_NOT_PARTICIPATE && quoteDetail?.notParticipateStatus;
  const notParticipateTitle = Parse(`Não participar: <span style="color:#858585;">${quoteDetail?.notParticipateStatusMessage ? unionMessage : quoteDetail?.notParticipateStatus}</span>`);
  const informationIndicator = quoteDetail?.userWhoSavedNotParticipateStatus && Parse(`<b><span style="color:#287C87">Por: </span>${quoteDetail?.userWhoSavedNotParticipateStatus}</b>`);

  const getCustomStatusForDisregarded = (status?: string) => {
    if (status === SupplierStatusType.DISREGARDED && !user?.isBCGUser) {
      return quoteDetail ? getCustomStatusDescription(quoteDetail, true) : status;
    }

    return status;
  };

  const viveoStatus = getCustomStatusForDisregarded(
    savedInMoneyPage ? integrationMessages?.statusViveo ?? quoteDetail?.supplierStatus : supplierStatus
  );

  return (
    <Container>
      <Row className="flex-1 py-1 info-header">
        <Column>
          <Text size={12} className="color-blueDark font-bold">
            Data de criação
          </Text>
          <Text size={12}>
            {quoteDetail?.createdAt != null
              ? format(new Date(quoteDetail?.createdAt), "dd/MM/yyyy' às 'HH:mm")
              : ""}
          </Text>
        </Column>
        <Column>
          <Text size={12} className="color-blue-gray font-bold mt-sm-1">
            Origem
          </Text>
          <Text size={12}>{quoteDetail?.origin}</Text>
        </Column>
        <Column>
          <Text size={12} className="color-blueDark font-bold mt-sm-1">
            Quantidade total de itens
          </Text>
          <Text size={12}>{quoteDetail?.itemsCount}</Text>
        </Column>
        <Column>
          <Text size={12} className="color-blueDark font-bold mt-sm-1">
            Expira em
          </Text>
          <Text size={12}>
            {quoteDetail?.expiresAt != null
              ? format(
                new Date(quoteDetail?.expiresAt),
                "dd/MM/yyyy' às 'HH:mm"
              )
              : ""}
          </Text>
        </Column>
        <Column>
          <Text size={12} className="color-blueDark font-bold mt-sm-1">
            Status Bionexo
          </Text>
          <Text size={12}>{quoteDetail?.status}</Text>
        </Column>
        <Column>
          <Text size={12} className="color-blueDark font-bold mt-sm-1">
            Status Viveo
          </Text>
          <Text size={12}>{viveoStatus}</Text>
        </Column>
        <Column className="break-spaces">
          <Text size={12} className="color-blueDark font-bold mt-sm-1">
            Informações adicionais
          </Text>
          <Text width={"160px"} size={12}>
            {quoteDetail?.additionalInfo}
          </Text>
        </Column>
        <Visibility visible={!!savedInMoneyPage}>
          <Column className={"mr-2"}>
            <Text size={12} className="color-blueDark font-bold mt-sm-1">
              Nº de orçamento
            </Text>
            <Text size={12}>{moneyBudgetValue && moneyBudgetValue.length ? moneyBudgetValue[0]?.code : "-"}</Text>
          </Column>
        </Visibility>
        <Visibility visible={!IsNullOrEmpty(quoteDetail?.contact?.name) || !IsNullOrEmpty(quoteDetail?.contact?.fone)}>
          <Column className="break-spaces mr-2">
            <Text size={12} className="color-blueDark font-bold mt-sm-1">
              Contato
            </Text>
            <Text className="" size={12}>
              {quoteDetail?.contact?.name} - {quoteDetail?.contact?.fone}
            </Text>
          </Column>
        </Visibility>
      </Row>
      <Row>
        <Column>
          <Visibility visible={!!notParticipateControl}>
            <HeaderIndicator
              key={undefined}
              title={notParticipateTitle}
              information={informationIndicator}
              indicatorColor={"#287C87"}
            />
          </Visibility>
        </Column>
      </Row>
    </Container>
  );
};

export default QuoteHeaderInformations;